import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import pdfMake from 'pdfmake/build/pdfmake'
import JsBarcode from 'jsbarcode'
import type { Content, TDocumentDefinitions } from 'pdfmake/interfaces'
import vfs from 'pdfmake/build/vfs_fonts.js';
import { formatarCnpjOuCpf } from './formatadores';
import { ValeTroca } from '@/models/venda/ValeTroca';


window.pdfMake.vfs = vfs.pdfMake.vfs;

function textToBase64Barcode(text: string): string {
	const canvas = document.createElement("canvas")
	if (!text) {
		canvas.width = 1
		canvas.height = 1
		return canvas.toDataURL("image/png")
	}
	JsBarcode(canvas, text, {
		height: 60,
		width: 1,
		displayValue: false,
	})
	return canvas.toDataURL("image/png")
}

function buildValeTrocaDocDefinition(valeTrocas: ValeTroca[]): TDocumentDefinitions {
	let valeTrocasPorQuant: Content[] = []
	valeTrocas.forEach(valeTroca => {
		const umValeTroca = Array.from(
			{ length: valeTroca.quantidade},
			() => gerarValeTroca(valeTroca),
		)
		valeTrocasPorQuant = [
			...valeTrocasPorQuant,
			...umValeTroca,
		]
	})
	let linhaValeTrocas: Content[][] = []
	const tamanho = 1
	for(let i = 0; i < valeTrocasPorQuant.length; i += tamanho) {
		const algunsValeTroca = valeTrocasPorQuant.slice(i, i + tamanho)
		const espacosVazios: Content[] = Array.from(
			{ length: tamanho - algunsValeTroca.length },
			() => [],
		)
		linhaValeTrocas = [
			...linhaValeTrocas,
			[...algunsValeTroca, ...espacosVazios],
		]
	}
	return {
		pageSize: { width: 230, height: 'auto' },
		pageMargins: [1, 1, 1, 1],
		pageOrientation: 'portrait',
		content: {
			table: { body: linhaValeTrocas },
			layout: 'noBorders',
		},
	}
}

export async function gerarValeTrocasBytes(valeTrocas: ValeTroca[]): Promise<Uint8Array> {
	const base64 = await gerarValeTrocas(valeTrocas)
	const binary = atob(base64)
	const bytes = new Uint8Array(binary.length)
	for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)
	return bytes
}

export async function gerarValeTrocas(valeTrocas: ValeTroca[]): Promise<string> {
	const docDefinition = buildValeTrocaDocDefinition(valeTrocas)
	return new Promise(resolve => {
		pdfMake.createPdf(docDefinition).getBase64((result) => resolve(result))
	})
}

export async function abrirValeTrocaEmTela(valeTrocas: ValeTroca[]): Promise<void> {
	const base64 = await gerarValeTrocas(valeTrocas)
	const binary = atob(base64)
	const bytes = new Uint8Array(binary.length)
	for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)
	const blob = new Blob([bytes], { type: 'application/pdf' })
	const url = URL.createObjectURL(blob)
	const link = document.createElement('a')
	link.href = url
	link.target = '_blank'
	link.rel = 'noopener noreferrer'
	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)
	URL.revokeObjectURL(url)
}




export function gerarValeTroca (valeTroca: ValeTroca): Content[] {
	return [
		{
			columns: [
				{ text: `CNPJ ${formatarCnpjOuCpf(valeTroca.loja.cnpj)}\n\n`, fontSize: 9, italics: true,  alignment: 'center'},
			
			],
		},
		{
			columns: [
				{ text: 'Vale Troca\n', fontSize: 15, alignment: 'center'},
				
			],
		},
		{
			columns: [
				{ text: 'Venda N°: ' + valeTroca.venda.identificador, alignment: 'center', fontSize: 11},

			],
		},
		{
			columns: [
				{ text: valeTroca.venda.dataHora ? dateTimeToPtBrFormat(valeTroca.venda.dataHora) : '', alignment: 'center', fontSize: 9},
				
			],
		},
		{
			columns: [
				{ image: textToBase64Barcode(valeTroca.venda.identificador || ''), alignment: 'center'},
			],
		},

	]

}
